// extracted by mini-css-extract-plugin
module.exports = {"CommentAdd":"CommentAdd_CommentAdd__2-69U","InFocus":"CommentAdd_InFocus__2Fqvl"};